import React from 'react';
import { ISigninButtonProps } from '../models/ISigninButtonProps';

import './FacebookSigninButton.scss';

export const FacebookSigninButton: React.FC<ISigninButtonProps> = (props: ISigninButtonProps) => {
    return (
        <span onClick={props.onClick}>
            <div className="facebook-signin">
                <span className="facebook-signin-icon" />
                <span className="facebook-signin-text">Sign in with Facebook</span>
            </div>
        </span>
    );
};
